import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { CatalogFilterBlueprint } from '@backstage/plugin-catalog-react/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { KindPicker } from './KindPicker';
import { SystemPicker } from './SystemFilter';

// Which kinds the catalog's Kind dropdown offers (and to whom) is in KindPicker.tsx.
const kindFilter = catalogPlugin
  .getExtension('catalog-filter:catalog/kind')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: {
          loader: async () => <KindPicker initialFilter={config.initialFilter} />,
        },
      });
    },
  });

// Adds a System dropdown (the stock catalog has none), so the list can be narrowed to one product.
const systemFilter = CatalogFilterBlueprint.make({
  name: 'system',
  params: { loader: async () => <SystemPicker /> },
});

export const catalogKindsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [kindFilter, systemFilter],
});
